import { Aperture, Contrast, Droplets, Sun, Thermometer } from 'lucide-react';

export const FILTER_SLIDERS = [
  { key: 'blur', labelKey: 'filterBlur', icon: Aperture, min: 0, max: 40 },
  { key: 'brightness', labelKey: 'filterBrightness', icon: Sun, min: -100, max: 100 },
  { key: 'contrast', labelKey: 'filterContrast', icon: Contrast, min: -100, max: 100 },
  { key: 'saturation', labelKey: 'filterSaturation', icon: Droplets, min: -100, max: 100 },
  { key: 'temperature', labelKey: 'filterTemperature', icon: Thermometer, min: -100, max: 100 },
];
